// components/LogLoader.js
import React from 'react';
import './LogLoader.css';

const LogLoader = () => {
  return (
    <div className="log-loading-spinner">
      <div className="spinner"></div>
    </div>
  );
};

export default LogLoader;
